import { useEffect } from "react";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { Button, Input, Row, Col, Select } from "antd";

const { Option } = Select;

const UniformPosition = ({ positionOptions, data, errors, append, remove, control,  }) => {

  
  

  
  const handleAddPosition = ()=>{
    append({
      "position": "",
      "cycle_period_in_months": ""
    })
  }

  // Pre-populate the form with existing uniform data using `reset`
  // useEffect(() => {
  //   if (data && data.length > 0) {
  //     // Map uniform data to the required format
  //     const mappedData = data.map((item) => ({
  //       position: item.position.id, // Use position ID
  //       cycle_period: item.cycle_period_in_months, // Use cycle period
  //     }));

  //     // Reset the form with pre-populated data
  //     reset({
  //       uniformDepartment: mappedData, // Ensure the key matches `useFieldArray` name
  //     });
  //   }
  // }, [data, reset]);

  return (
    <div>
      {/* Add Row Button */}
      <Button
        className="mb-3"
        type="primary"
        onClick={handleAddPosition}
      >
        Add Position
      </Button>

      {/* Dynamic Rows */}
      {data.map((field, index) => (
        <Row key={field.id} gutter={16} className="mb-3">
          {/* Department Name Dropdown */}
          <Col span={12}>
            <label>Position</label>
            <Controller
              name={`positions.${index}.position`}
              control={control}
              defaultValue={field.position} // Set default value
              render={({ field }) => (
                <Select
                  {...field}
                  style={{ width: "100%" }}
                  placeholder="Select Position"
                >
                  {positionOptions.map((dept) => (
                    <Option key={dept.value} value={dept.value}>
                      {dept.label}
                    </Option>
                  ))}
                </Select>
              )}
            />
            {errors.positions?.[index]?.position && (
              <small className="text-danger">
                {errors.positions[index].position.message}
              </small>
            )}
          </Col>

          {/* Cycle Period Input */}
          <Col span={8}>
            <label>Cycle Period (months)</label>
            <Controller
              name={`positions.${index}.cycle_period_in_months`}
              control={control}
              defaultValue={field.cycle_period_in_months} // Set default value
              render={({ field }) => (
                <Input {...field} type="number" placeholder="Enter Cycle Period" />
              )}
            />
            {errors.positions?.[index]?.cycle_period_in_months && (
              <small className="text-danger">
                {errors.positions[index].cycle_period_in_months.message}
              </small>
            )}
          </Col>

          {/* Remove Button */}
          <Col span={4}>
            <Button
              danger
              onClick={() => remove(index)}
              style={{ marginTop: 22 }}
            >
              Remove
            </Button>
          </Col>
        </Row>
      ))}
    </div>
  );
};

export default UniformPosition;
